import React, { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"

const Pagination = ({
	currentpage,
	prevPage,
	totalpages,
	docsToSHow,
	nextPage,
	setCurrentPage,
	setDocumentsBulk = () => {},
	setAllChecked = () => {},
}) => {
	/* ******************* REDUX STORE ******************* */

	/* ******************* END REDUX STORE ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	const updateCurrentPage = (e) => {
		setCurrentPage(e)
		setDocumentsBulk([])
		setAllChecked(false)
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	return (
		<Fragment>
			<div className="col-12 d-flex justify-content-center mt-20 mb-5">
				<div className="col-8 d-flex justify-content-center mt-20">
					{currentpage <= 1 ? null : (
						<div className="d-flex justify-content-center">
							<div>
								<button
									type="button"
									className="btn btn-primary"
									style={{ marginRight: "10px" }}
									onClick={(e) => {
										e.preventDefault()
										prevPage()
										setDocumentsBulk([])
										setAllChecked(false)
									}}
								>
									&laquo; Prev
								</button>
							</div>
							<div className="vertical-align borderPagination">
								<a
									className="numPages"
									onClick={(e) => {
										e.preventDefault()
										updateCurrentPage(currentpage - 3)
									}}
								>
									{currentpage - 3 > 0 ? currentpage - 3 : null}
								</a>
								<a
									className="numPages"
									onClick={(e) => {
										e.preventDefault()
										updateCurrentPage(currentpage - 2)
									}}
								>
									{currentpage - 2 > 0 ? currentpage - 2 : null}
								</a>
								<a
									className="numPages"
									onClick={(e) => {
										e.preventDefault()
										updateCurrentPage(currentpage - 1)
									}}
								>
									{currentpage - 1 > 0 ? currentpage - 1 : null}
								</a>
							</div>
						</div>
					)}

					{docsToSHow.count === 0 ? null : (
						<div className="vertical-align borderPagination selected">
							<a href="#" className="numPages">
								<b>{currentpage}</b>
							</a>
						</div>
					)}

					{currentpage === totalpages || Number.isNaN(totalpages) || docsToSHow.count === 0 ? null : (
						<div className="d-flex justify-content-center">
							<div className="vertical-align borderPagination">
								<a
									className="numPages"
									onClick={(e) => {
										e.preventDefault()
										updateCurrentPage(currentpage + 1)
									}}
								>
									{currentpage + 1 <= totalpages ? currentpage + 1 : null}
								</a>
								<a
									className="numPages"
									onClick={(e) => {
										e.preventDefault()
										updateCurrentPage(currentpage + 2)
									}}
								>
									{currentpage + 2 <= totalpages ? currentpage + 2 : null}
								</a>
								<a
									className="numPages"
									onClick={(e) => {
										e.preventDefault()
										updateCurrentPage(currentpage + 3)
									}}
								>
									{currentpage + 3 <= totalpages ? currentpage + 3 : null}
								</a>
							</div>

							<div>
								<button
									type="button"
									className="btn btn-primary"
									style={{ marginLeft: "10px" }}
									onClick={(e) => {
										e.preventDefault()
										nextPage()
										setDocumentsBulk([])
										setAllChecked(false)
									}}
								>
									Next &raquo;
								</button>
							</div>
						</div>
					)}
				</div>
			</div>
		</Fragment>
	)
}

export default Pagination
